import "core-js/stable";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Router, Route, BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
// Intl
//import { addLocaleData } from "react-intl";
// Lang
//import en from "react-intl/locale-data/en";
//import no from "react-intl/locale-data/no";
// Components
import App from './components/App/App';
import store, { history } from './store';
import { unregister } from './registerServiceWorker';
import { localeSet } from './actions/actionCreators';

//addLocaleData([...en, ...no]);

// Adding language preference to localstorage
if (localStorage.alhubLang) {
    store.dispatch(localeSet(localStorage.alhubLang));
}

const root = document.getElementById('root');
createRoot(root).render(
    // <Router history={history}>
    //     <Provider store={store}>
    //         <Route component={App} />
    //     </Provider>
    // </Router>
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

unregister();
